import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "../lib/i18n";

const LINKS = [
  ["story", "/story"],
  ["party", "/wedding-party"],
  ["weekend", "/weekend"],
  ["venue", "/venue"],
  ["travel", "/travel"],
  ["faq", "/faq"],
  ["registry", "/registry"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { lang, toggle, c } = useLang();

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FAFAF1]/70 border-b border-[#DFE4D0]/60">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          data-testid="nav-logo"
          to="/"
          onClick={() => setOpen(false)}
          className="font-serif-display text-2xl tracking-wide text-[#2C3552]"
        >
          P<span className="italic text-[#E15A70]">&</span>L
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map(([id, path]) => (
            <NavLink
              key={id}
              data-testid={`nav-link-${id}`}
              to={path}
              className={({ isActive }) =>
                `text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 border-b pb-0.5 ${
                  isActive
                    ? "text-[#E15A70] border-[#E15A70]"
                    : "text-[#2C3552]/70 border-transparent hover:text-[#465220]"
                }`
              }
            >
              {c.nav[id]}
            </NavLink>
          ))}
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            className="text-[11px] uppercase tracking-[0.22em] text-[#465220] border border-[#A9B08C]/70 rounded-full px-3.5 py-1.5 hover:bg-[#A9B08C]/20 transition-colors duration-300"
          >
            {lang === "en" ? "ES" : "EN"}
          </button>
          <Link
            data-testid="nav-rsvp-btn"
            to="/rsvp"
            className="text-[11px] uppercase tracking-[0.22em] px-5 py-2.5 rounded-full bg-[#2C3552] text-[#FAFAF1] hover:bg-[#E15A70] transition-colors duration-300"
          >
            RSVP
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#2C3552]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden bg-[#FAFAF1]/95 backdrop-blur-xl border-b border-[#DFE4D0]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              <button
                data-testid="lang-toggle-mobile"
                onClick={() => {
                  toggle();
                  setOpen(false);
                }}
                className="text-left text-[11px] uppercase tracking-[0.25em] text-[#465220]"
              >
                {lang === "en" ? "Español" : "English"}
              </button>
              {[...LINKS, ["rsvp", "/rsvp"]].map(([id, path]) => (
                <Link
                  key={id}
                  data-testid={`nav-mobile-link-${id}`}
                  to={path}
                  onClick={() => setOpen(false)}
                  className="text-left font-serif-display text-2xl text-[#2C3552] hover:text-[#E15A70] transition-colors duration-300"
                >
                  {c.nav[id]}
                </Link>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
